'use client'

import { motion } from 'framer-motion'
import { PricingConfigurator } from '@/components/PricingConfigurator'

export default function GetStartedPage() {
  return (
    <main className="min-h-screen">
      {/* Hero */}
      <section className="relative min-h-[40vh] flex items-center overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0">
          <div className="absolute inset-0" style={{ background: 'var(--hero-ground)' }} />
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5 }}
            className="absolute top-0 left-0 right-0 h-[55%]"
            style={{
              background: 'linear-gradient(180deg, var(--accent-primary) 0%, var(--accent-warm) 60%, transparent 100%)',
              filter: 'blur(40px)',
              opacity: 0.6,
            }}
          />
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5, delay: 0.3 }}
            className="absolute bottom-0 left-0 right-0 h-[40%]"
            style={{
              background: 'linear-gradient(0deg, var(--accent-secondary) 0%, var(--accent-deep) 50%, transparent 100%)',
              filter: 'blur(60px)',
              opacity: 0.5,
            }}
          />
        </div>

        {/* Content */}
        <div className="relative z-10 w-full px-6 py-20">
          <div className="max-w-3xl mx-auto text-center">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="font-display text-4xl md:text-5xl font-light tracking-tight mb-4"
              style={{ color: 'var(--accent-cream)' }}
            >
              Build your plan
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="text-xl"
              style={{ color: 'rgba(255,255,255,0.7)' }}
            >
              Configure exactly what you need. From individual access to enterprise-scale intelligence.
            </motion.p>
          </div>
        </div>
      </section>

      {/* Configurator */}
      <section className="py-16 px-6">
        <PricingConfigurator />
      </section>

      {/* Trust indicators */}
      <section className="py-12 px-6 bg-card border-t border-border">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-8 text-text-tertiary text-sm">
            <span>Cancel anytime</span>
            <span>50+ years of data</span>
            <span>SOC 2 compliant</span>
            <span>Secure payments via Stripe</span>
          </div>
        </div>
      </section>
    </main>
  )
}
